import gsap from 'gsap';

  ///////////////////////////////
 ////// Helper functions ///////
///////////////////////////////
const subScenePauseTime = 3;

function getOutTimeBasedOnPauseTime(pauseTime) {
  return scene => scene.startTime + scene.inDuration + (scene.pauses || 0) * pauseTime;
}

const getOutTime = getOutTimeBasedOnPauseTime(subScenePauseTime);

export function getStartLabel(i) {
  return scenes[i].name + 'Start';
}

export function getEndLabel(i) {
  return scenes[i].name + 'End';
}

export function getSubLabel(sceneIndex, subIndex) {
  return scenes[sceneIndex].name + subIndex;
}

function addPauses(timeline, scenes) {
  scenes.forEach(({name}, i) => {
    timeline.addPause(getEndLabel(i));
  })
}

function addLabels(timeline, scenes) {
  scenes.forEach(({name, startTime, inDuration, pauses}, i) => {
    timeline
        .addLabel(getStartLabel(i), startTime)
        .addLabel(getEndLabel(i), getOutTime({startTime, inDuration, pauses}));
  });
}

function addSubSceneLabels(timeline, subLabels) {
  subLabels.forEach((labels) =>
      timeline.addLabel(...labels)
  );
}

function addSubScenePauses(timeline, pauseLabels) {
  pauseLabels.forEach(([label]) =>
      timeline.addPause(label)
  );
}

function getTimeline() {
  return gsap.timeline();
}

function sumDurations (scene) {
  return scene.startTime
      + scene.inDuration
      + scene.outDuration
      + (scene.pauses || 0) * subScenePauseTime
      ;
}

function addStartTimes(scenes) {
  const updatedScenes = [...scenes];
  updatedScenes.forEach((scene, i) => updatedScenes[i] = {
    ...scene,
    startTime: i > 0 ? sumDurations(updatedScenes[i - 1]) : scene.startTime,
  });
  return updatedScenes;
}

function getSubSceneLabels(scenes) {
  return scenes
      .filter(({pauses}) => Boolean(pauses))
      .map(({pauses, name, startTime, inDuration}) => Array.from(new Array(pauses))
          .map((_, i) => {
            const time = startTime + inDuration + (i + 1) * subScenePauseTime;
            return [name + i, time];
          })
      )
      .flat()
      ;
}

function setTimelinePosition(timeLine) {
  return (label) => {
    timeLine.seek(label, true);
    timeLine.play();
  }
}

  ////////////////////////////////
 ////// Setup main scenes ///////
////////////////////////////////

// Scene definition array
const s1 = [
  {
    name: 'planets',
    startTime: 0,
    inDuration: 5.5,
    outDuration: 0.5,
  },
  {
    name: 'introTwo',
    startTime: 0,
    inDuration: 5.5,
    outDuration: 0.5,
  },
  {
    name: 'introThree',
    startTime: 0,
    inDuration: 5.5,
    outDuration: 0.5,
  },
  {
    name: 'gnosis',
    inDuration: 4.5,
    outDuration: 1.5,
    pauses: 4,
  },
  {
    name: 'telescope',
    inDuration: 4.5,
    outDuration: 1.5,
    pauses: 2,
  },
  {
    name: 'lighthouse',
    inDuration: 6,
    outDuration: 1.5,
  },
  {
    name: 'leaders',
    inDuration: 4.5,
    outDuration: 1.5,
    pauses: 9,
  },
  {
    name: 'path',
    inDuration: 4.5,
    outDuration: 4,
    pauses: 3,
  },
  {
    name: 'magnifyingGlass',
    inDuration: 5.5,
    outDuration: 1.5,
    pauses: 3,
  },
  {
    name: 'threeLeaders',
    inDuration: 7,
    outDuration: 1.5,
    pauses: 3,
  },
  {
    name: 'building',
    inDuration: 4.5,
    outDuration: 3.5,
    pauses: 4,
  },
  {
    name: 'circle',
    inDuration: 7.5,
    outDuration: 1.5,
  },
  {
    name: 'customerJourney',
    inDuration: 14,
    outDuration: 1.5,
    pauses: 1,
  },
  {
    name: 'gnosisFinal',
    inDuration: 6.5,
    outDuration: 1.5,
  },
];


// Add start times to scenes array
export const scenes = addStartTimes(s1);

// Create labels helper object
export const labels = scenes
    .map(({name}, i) => ({
      [name + 'Start']: getStartLabel(i),
      [name + 'End']: getEndLabel(i)
    }))
    .reduce((a, b) => ({...a, ...b}));


  ///////////////////////////////
 ////// Setup sub scenes ///////
///////////////////////////////
const subSceneLabels = getSubSceneLabels(scenes);


  //////////////////////////////////
 ////// Setup main timeline ///////
//////////////////////////////////
const getMainTimeline = () => {
  const mainTimeline = getTimeline();
  addLabels(mainTimeline, scenes);
  addPauses(mainTimeline, scenes);
  addSubSceneLabels(mainTimeline, subSceneLabels);
  addSubScenePauses(mainTimeline, subSceneLabels);

  const setTime = setTimelinePosition(mainTimeline);

  return {
    mainTimeline,
    setTime,
  }
}

export const {mainTimeline, setTime} = getMainTimeline();